import styled from 'styled-components'

const SideBarSize = 78

export const Container = styled.div`
  width: 100vw;
  min-height: calc(100vh - 200px);
  margin-top: 50px;
  padding: 0 1.5rem;

  @media only screen and (min-width: 800px) {
    margin: 60px 32px 0 ${SideBarSize + 32}px;
    padding: 0;

    width: unset;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`

export const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media only screen and (min-width: 900px) {
    gap: 32px;
  }
`

export const UpperContent = styled.div`
  width: 100%;

  .title {
    font-size: 24px;
    line-height: 120%;

    margin-top: 24px;
  }

  .search-options {
    display: flex;
    flex-direction: column;

    gap: 12px;
  }

  @media only screen and (min-width: 900px) {
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;

    .title {
      font-size: 32px;
      margin: 0;
    }

    .search-options {
      flex-direction: row;
      gap: 24px;

      .checkbox-label {
        white-space: nowrap;
      }
    }
  }
`

export const SearchBar = styled.label`
  border-radius: 8px;
  width: 100%;

  padding: 1rem;

  max-width: 348px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

  svg {
    height: 1rem;
    margin-right: 0.5rem;
    color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
  }

  input {
    border: none;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    width: 100%;
    font-size: 1.125rem;

    &::placeholder {
      color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
    }
  }
`

export const EmptyText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;

  .empty-text {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    /* or 25px */

    display: flex;
    align-items: center;
    text-align: center;

    /* Dark Gray/100 */

    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }

  .loading {
    -webkit-animation: breathing 5s ease-out infinite normal;
    animation: breathing 5s ease-out infinite normal;
  }

  @-webkit-keyframes breathing {
    0% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }

    25% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }

    60% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }

    100% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
  }

  @keyframes breathing {
    0% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }

    25% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }

    60% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }

    100% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }
  }
`

export const List = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media only screen and (min-width: 900px) {
    width: unset;

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 1rem;
  }
`
export const Card = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: 20px;
  border-style: solid;
  border-width: 2px;

  border-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};

  &[data-read='false'] {
    border-color: ${({ theme }) => `rgb(${theme.primary.base})`};
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    background-color: ${({ theme }) => `rgba(${theme.background.low}, 0.5)`};
    margin: 0;

    height: 100%;

    padding: 24px;

    .wrapper {
      display: flex;
      gap: 8px;

      margin-bottom: 24px;

      .icon {
        width: 22px;
        height: 22px;

        flex-shrink: 0;
        border-radius: 4px;

        object-fit: cover;
      }

      .course-name {
        font-weight: bold;
        color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
      }

      .link {
        text-decoration: underline;
        color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

        transition: 200ms color ease;

        &:hover {
          color: ${({ theme }) => `rgb(${theme.primary.base})`};
        }
      }

      .texts {
        display: flex;
        flex-direction: column;
        gap: 4px;

        font-size: 14px;
        font-weight: 400;
        line-height: 19px;
        letter-spacing: -0.01em;

        .label {
          color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
          margin-right: 4px;
        }
      }
    }

    .short-description {
      font-size: 16px;
      font-weight: 500;
      line-height: 23px;
      letter-spacing: -0.01em;

      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;

      word-break: break-word;
    }
  }

  .footer {
    display: flex;
    flex-direction: column;
    padding: 18px 24px;
    gap: 20px;

    .date {
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: -0.01em;

      color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
    }

    .link {
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: 0em;

      border-radius: 4px;

      color: ${({ theme }) => `rgb(${theme.background.high})`};
      background-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      padding: 12px 0;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media only screen and (min-width: 900px) {
    min-width: 360px;

    .title {
      font-size: 22px;
      line-height: 30px;
    }

    .content {
      padding: 22px 22px 4px 22px;

      .wrapper {
        .course-name {
          font-size: 16px;
        }
      }
      .short-description {
        -webkit-line-clamp: 4;
      }
    }

    .footer {
      padding: 4px 22px 24px 22px;

      background-color: ${({ theme }) => `rgba(${theme.background.low}, 0.5)`};
    }
  }

  @media only screen and (min-width: 1200px) {
    min-width: 490px;

    .footer {
      position: relative;

      .date {
        color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
      }

      .link {
        width: 122px;
        align-self: center;
      }
    }
  }
`

export const LoadingContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  .loading-block {
    height: 380px;
  }

  @media only screen and (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
  }
`

export const PaginationContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  display: flex;
  gap: 12px;

  button {
    background-color: ${({ theme }) => `rgb(${theme.background.low})`};

    border: 0;
    border-radius: 4px;

    box-shadow: ${({ theme }) =>
      theme.isDark
        ? 'none'
        : 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px'};

    width: 30px;
    height: 30px;

    font-size: 14px;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    &[data-active='true'] {
      color: rgb(249, 249, 249);
      font-weight: bold;
      background-color: ${({ theme }) => `rgba(${theme.primary.base})`};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`
